import { fetcher } from "../api/fetcher";

export const domains = {
  livekit_host: "",
  main_host: "",
};

export function domain_once() {
  if (domains.main_host === "" || domains.livekit_host === "") {
    return fetcher
      .get({
        path: "/settings",
      })
      .then((res) => {
        Object.assign(domains, res);
      });
  } else return true;
}
